<template>
  <div class="block-head pb-12">
    <img src="/dist/assets/front_white/img/landing_plugin/bg-picture.svg" alt="" class="block-head__image" />
    <bim-text class="block-head__title" type="h3" bold>{{ $t("Создан инженерами для инженеров") }}</bim-text>
    <bim-text class="block-head__text" type="h5">{{ $t("Работайте с BIM-библиотекой напрямую из САПР.") }}<br />{{ $t("Подбирайте аналоги продуктов легко.") }}</bim-text>
  </div>
</template>

<script>
import bimCol from "@bimlib/components/bimCol"
export default {
  name: "",
  components: {
    bimCol
  }
}
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/settings";

.block-head {
  .block-head__image {
    width: 100%;
  }

  .block-head__title {
    padding: 38px 0 24px;
    line-height: 1.08;
    
    @media screen and (max-width: $breakpoint-sm) {
      ::v-deep .text__inner {
        font-size: 24px;
      }
    }
  }

  .block-head__text {
    line-height: 1.22;

    @media screen and (max-width: $breakpoint-sm) {
      ::v-deep .text__inner {
        font-size: 18px;
      }
    }
  }

  .block-head__text,
  .block-head__title {
    text-align: center;
    width: 100%;
  }
}
</style>
